module.exports = __webpack_public_path__ + "img/icons B_22.7502e276.png";